import { createSlice } from "@reduxjs/toolkit";
export const changeSlice=createSlice({
    name:"change",
    initialState:{
        value:{

            cour:{},
            typeOperation:'',
            montantToExchane:0,
            MontantToReceive:0,  
            // deviseInit:'MAD Marocain'
        }
    },
    reducers:{
        convert:(state,action)=>{
            state.value={...state.value,typeOperation:action.payload}
        },
        change:(state,action)=>{
            state.value={...state.value,
                typeOperation:action.payload.TypeOperation,
                cour:action.payload.cour,
                bureau:action.payload.bureau,
                devise:action.payload.devise,
                montantToExchane:action.payload.montantToExchane,
                MontantToReceive:action.payload.MontantToReceive}
        },

        mdifMontantToChange:(state,action)=>{
            // state.value={montantToExchane:actionn.payload.montant1,MontantToReceive:actionn.payload.montant2}
            state.value= {...state.value,montantToExchane:action.payload.montant1,MontantToReceive:action.payload.montant2}
        },        
        deviseToChange:(state,action)=>{
            state.value={...state.value,deviseToExchange:action.payload,montantToExchane:0,MontantToReceive:0}
        },      
    }
});
 export const {convert,mdifMontantToChange,deviseToChange,change}=changeSlice.actions;
 export default changeSlice.reducer;